module.exports = __webpack_public_path__ + "img/icon-mind-logo.fd6033a1.png";